export default __webpack_public_path__ + "static/media/saygaysmall.554c26e8.jpg";